import React, { useState, useEffect } from "react";
import Layout from "../containers/layout";
import axios from "axios";
import {
  BlockStack,
  Box,
  Button,
  Card,
  Page,
  Spinner,
  Text,
  TextField,
  Toast,
} from "@shopify/polaris";

const payload = {
  orderid: "",
  locationcode: "",
  orderDate: "",
  ordervalue: "",
};

function convertDateFormat(inputDate) {
  const parts = inputDate.split("-");
  const formattedDate = parts.join("");

  return formattedDate;
}

const CancelOrder = () => {
  const [loading, setloading] = useState(false);
  const [dateValue, setDateValue] = useState("");
  const [inputData, setInputData] = useState(payload);

  const InputHandler = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
  };

  useEffect(() => {
    if (inputData) {
      const newformatDate = convertDateFormat(dateValue);
      setInputData({ ...inputData, orderDate: newformatDate });
    }
  }, [dateValue]);

  const [toast, setToast] = useState(null);
  const showToast = (tone, message) => {
    setToast({ tone, message });
    setTimeout(() => setToast(null), 5000);
  };

  

  const apiurl = "https://api.iplanet.one";

  const CancelHandler = (e) => {
    e.preventDefault();

    if (
      !inputData?.orderid ||
      !inputData.orderDate ||
      !inputData.locationcode
    ) {
      showToast("warning", "All fields are mandatory");
      return;
    }

    setloading(true);

    axios
      .post(`${apiurl}/orders/cancelorder`, inputData, {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        const result = res?.data?.data?.Response?.Result;

        if (res.data?.success && result !== "FAILURE") {
          showToast("success", "Order Cancelled Successfully");
          setInputData(payload);
          setDateValue("");
        } else {
          showToast("critical", "Check field again");
        }
      })
      .catch(() => {
        showToast("critical", "Something went wrong");
      })
      .finally(() => {
        setloading(false);
      });
  };

 
  return (
    <Layout>
      <Page fullWidth>
        <BlockStack gap="600" align="center">
          <Card padding="600" maxWidth="900px">
            <BlockStack gap="500" align="center">
              <BlockStack align="center" gap="200">
                <Text variant="heading2xl" as="h1" alignment="center">
                  Cancel Order
                </Text>
                <Text variant="bodyMd" tone="subdued" alignment="center">
                  Cancel order from Wondersoft
                </Text>
              </BlockStack>

              <Card background="bg-surface-secondary" rounded="300">
                <Box padding="400">
                  <BlockStack gap="400">
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "1rem",
                        alignItems: "end",
                      }}
                    >
                      <TextField
                        label="Order ID"
                        placeholder="Order Id"
                        value={inputData.orderid}
                        name="orderid"
                        onChange={(value) =>
                          InputHandler({ target: { name: "orderid", value } })
                        }
                        autoComplete="off"
                        disabled={loading}
                      />

                      <TextField
                        label="Location Code"
                        placeholder="Location Code"
                        value={inputData.locationcode}
                        name="locationcode"
                        onChange={(value) =>
                          InputHandler({
                            target: { name: "locationcode", value },
                          })
                        }
                        autoComplete="off"
                        disabled={loading}
                      />

                      <TextField
                        label="Order Date"
                        type="date"
                        value={dateValue}
                        onChange={(value) => setDateValue(value)}
                        autoComplete="off"
                        disabled={loading}
                      />

                      <TextField
                        label="Total Order Value"
                        type="number"
                        placeholder="Total Order Value"
                        value={inputData.ordervalue}
                        name="ordervalue"
                        onChange={(value) =>
                          InputHandler({
                            target: { name: "ordervalue", value },
                          })
                        }
                        autoComplete="off"
                        disabled={loading}
                      />

                      <Button
                        variant="primary"
                        size="large"
                        submit
                        loading={loading}
                        disabled={loading}
                        onClick={CancelHandler}
                      >
                        {loading ? <Spinner size="small" /> : "Cancel Order"}
                      </Button>
                    </Box>
                  </BlockStack>
                </Box>
              </Card>
              {toast && (
                <Toast
                  content={toast.message}
                  tone={toast.tone}
                  onDismiss={() => setToast(null)}
                />
              )}
            </BlockStack>
          </Card>
        </BlockStack>
      </Page>
    </Layout>
  );
};

export default CancelOrder;
